// 收付款 关联 订单金额
<template>
  <div class="clearfix choose-match-invoice">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="tabVal" size="medium" @change="change">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="new">新订单2.0</vxe-radio>
          </li>
          <li v-if="isSub">
            <vxe-radio name="xtabs" label="sub">附属订单</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="my-search" v-show="tabVal === 'new'">
        <vxe-input
            v-model="searchOrdersNum"
            style="width: 150px"
            type="text"
            placeholder="输入订单编号"
            @keyup.enter.native="search"
            clearable
        ></vxe-input>
        <vxe-input
            v-model="searchOrdersName"
            type="text"
            placeholder="输入订单标题"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
            clearable
        ></vxe-input>
        <!-- <vxe-input
          v-model="searchOrdersBuyer"
          type="search"
          placeholder="输入托运人名称"
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        ></vxe-input> -->
        <Select
            v-model="searchOrdersBuyer"
            filterable
            prefix="ios-arrow-down"
            clearable
            :remote-method="
            file =>
              remoteMethod(
                file,
                'buyerNameOptions',
                'twoOrders',
                'searchCondition',
                3
              )
          "
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="
            file => setDefaultOptions(file, 'buyerNameOptions')
          "
            placeholder="输入托运人名称"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
        >
          <Option
              v-for="option in buyerNameOptions"
              :value="option.name"
              :key="option.name"
          >{{ option.name }}
          </Option>
        </Select>
        <!-- <vxe-input
          v-model="searchOrdersCompName"
          type="search"
          placeholder="输入平台企业"
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        ></vxe-input> -->
        <!-- <vxe-input
          v-model="searchOrdersSeller"
          type="search"
          placeholder="输入承运人名称"
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        ></vxe-input> -->
        <Select
            v-model="searchOrdersSeller"
            filterable
            prefix="ios-arrow-down"
            clearable
            :remote-method="
            file =>
              remoteMethod(
                file,
                'sellerNameOptions',
                'twoOrders',
                'searchCondition',
                4
              )
          "
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="
            file => setDefaultOptions(file, 'sellerNameOptions')
          "
            placeholder="输入承运人名称"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
        >
          <Option
              v-for="option in sellerNameOptions"
              :value="option.name"
              :key="option.name"
          >{{ option.name }}
          </Option>
        </Select>
        <vxe-input
            v-model="searchOrdersCarShipNum"
            type="text"
            placeholder="输入车船号"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
            clearable
        ></vxe-input>
        <vxe-input
            v-model="searchOrdersSaleMan"
            type="text"
            placeholder="输入业务员"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
            clearable
        ></vxe-input>
        <Button type="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 4px;">搜索
        </Button>
      </div>
      <div class="my-search" v-show="tabVal === 'sub'">
        <vxe-input v-model="ordersNumAttached" style="width: 150px" type="text" placeholder="输入订单编号"
                   @keyup.enter.native="search2" clearable></vxe-input>
        <vxe-input v-model="ordersTitleAttached" type="text" placeholder="输入订单标题" @keyup.enter.native="search2"
                   style="width: 150px; margin-left: 10px" clearable></vxe-input>
        <Select
            v-model="searchComp"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'compOptions', 'twoOrders', 'queryAttachedOrderKeyword', 6)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'compOptions')"
            placeholder="输入所属公司"
            style="width: 200px; margin-left: 10px"
        >
          <Option v-for="option in compOptions" :value="option.id" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            v-model="searchSellerName"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'sellerOptions', 'twoOrders', 'queryAttachedOrderKeyword', 2)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'sellerOptions')"
            placeholder="输入销售方"
            style="width: 200px; margin-left: 10px"
        >
          <Option v-for="option in sellerOptions" :value="option.id" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            v-model="searchSalesMan"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'salesManOptions', 'twoOrders', 'queryAttachedOrderKeyword', 3)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
            placeholder="输入业务员"
            style="width: 200px; margin-left: 10px"
        >
          <Option v-for="option in salesManOptions" :value="option.id" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Button type="primary" icon="ios-search" @click="search2" style="margin-left: 10px;border-radius: 4px;">搜索
        </Button>
      </div>
    </div>

    <div class="add-box clearfix" v-show="tabVal === 'new'">
      <vxe-table
          border="none"
          show-overflow
          keep-source
          class="table-style"
          align="center"
          ref="xTable"
          max-height="450"
          highlight-hover-row
          :data="tableData"
          :loading="loading"
          :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
          @cell-click="cellClick"
          @checkbox-change="checkboxChange"
          @checkbox-all="checkBoxAll"
      >
        <vxe-table-column type="checkbox" field="checked" align="center" width="60" v-if="isEdit"></vxe-table-column>
        <vxe-table-column field="aboutAmount" title="关联金额" width="150" v-if="isEdit">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.aboutAmount"
                placeholder="输入关联金额"
                v-on:input="inputAboutAmount(scope.row)"
                @input="$refs.xTable.updateStatus(scope)"
                v-if="scope.row.checked == true"
                type="number"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="aboutAmount" title="关联金额" width="150" v-else></vxe-table-column>

        <vxe-table-column field="ordersNum" title="订单编号" width="130">
          <template slot-scope="{ row }">
            <a v-if="!isEdit" @click="openOrderDetail(row.id)">{{ row.ordersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersTitle" title="订单标题" width="150"></vxe-table-column>
        <vxe-table-column field="ordersState" title="订单状态" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.ordersState | ordersStateMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerName" title="托运人" width="150" align="center"></vxe-table-column>
        <vxe-table-column field="compName" title="平台企业" width="200"></vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人" width="150" align="center"></vxe-table-column>

        <vxe-table-column field="goodsName" title="货名" width="105" align="center"></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="75" align="center"></vxe-table-column>
        <vxe-table-column field="saleMan" title="业务员" width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          style="margin-top: 20px"
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <div class="add-box clearfix" v-show="tabVal === 'sub'">
      <vxe-table
          border="none"
          show-overflow
          keep-source
          class="table-style"
          align="center"
          ref="xTable2"
          max-height="450"
          highlight-hover-row
          :data="orderListData"
          :loading="loading"
          :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
          @checkbox-change="checkboxChange2"
          @checkbox-all="checkBoxAll2"
      >
        <vxe-table-column type="checkbox" field="checked" align="center" width="60" v-if="isEdit"></vxe-table-column>
        <vxe-table-column field="aboutAmount" title="关联金额" width="150" v-if="isEdit">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.aboutAmount"
                placeholder="输入关联金额"
                v-on:input="inputAboutAmount(scope.row)"
                @input="$refs.xTable2.updateStatus(scope)"
                v-if="scope.row.checked === true"
                type="number"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="aboutAmount" title="关联金额" width="150" v-else></vxe-table-column>
        <vxe-table-column field="blanaceAmount" title="未付金额" min-width="130"></vxe-table-column>
        <vxe-table-column field="ordersNumAttached" title="订单编号" min-width="130">
          <template slot-scope="{ row }">
            <a @click="openDetail(row.id)">{{ row.ordersNumAttached }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="relOrdersNum" title="关联主订单" min-width="120" align="center">
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.relOrdersId)">{{ row.relOrdersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="所属公司" min-width="120"></vxe-table-column>
        <vxe-table-column field="ordersTypeText" title="订单类型" min-width="80" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ordersTypeText }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersTitleAttached" title="订单标题" width="150"></vxe-table-column>
        <vxe-table-column field="sellerName" title="销售方" width="200"></vxe-table-column>
        <vxe-table-column field="saleMan" title="业务员" min-width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" min-width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          style="margin-top: 20px"
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>

    <div class="footer-wrap" style="margin-bottom: 15px" v-if="isEdit">
      <Button status="primary" @click="submit(true)">提交</Button>
      <div>
        <span>可关联金额为:</span> ¥
        <span style="color: blue">{{ payAmount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {isEmpty, isNotEmpty} from "@/utils/util";
import {numberToCurrency, numberToMoney} from "@/filters/type";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  name: "PaymentAboutOrder",
  mixins: [getAuthOrization],
  props: {
    chainId: Number,
    isEdit: {
      type: Boolean,
      default: true
    },
    isSub: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      cate: "", // 选择的订单类型,  Collection 购买方订单  Payment SellerPayment 承运人订单
      platformCompanyId: "", //所属平台
      searchOrdersNum: "", //搜索订单号
      searchOrdersName: "", //搜索托运人 或 承运人 实际承运人 名称
      searchOrdersBuyer: "",
      searchOrdersCompName: "",
      searchOrdersSeller: "",
      searchOrdersCarShipNum: "",
      searchOrdersSaleMan: "",
      platformCompany: null,
      buyerName: "",
      loading: false,
      loading2: false,
      payAmount: 0,
      tableData: [],
      orderListData: [],
      isCheckboxAll: false,
      isCheckboxAll2: false,
      checkboxConfig: {
        labelField: "操作",
        checkField: "checked"
      },
      currentPage: 0,
      currentPage2: 0,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      page2: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      resMoneyMap: {},
      paymentsId: null,
      searchLoading: false,
      buyerNameOptions: [], // 搜索托运人下拉框
      sellerNameOptions: [],
      tabVal: 'new',
      orderType: [],
      ordersNumAttached: null,
      ordersTitleAttached: null,
      searchComp: [],
      compOptions: [],
      searchSellerName: [],
      sellerOptions: [],
      searchSalesMan: [], // 搜索业务员字段
      salesManOptions: [], // 搜索业务员下拉框
    };
  },
  watch: {
    cate: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (oldVal) {
          if (val == "Payment" || val == "SellerPayment") {
            this.getOrderList();
          }
        }
      }
    }
  },
  created() {
    // this.getSelData();
    this.getDict(59000, 'orderType');
  },
  methods: {
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    change(e) {
      if (this.isEdit) {
        this.resMoneyMap = {};
        if (e.label === 'new') {
          this.getOrderList();
        } else {
          this.getSubOrder();
        }
      }
    },
    openOrderDetail(id) {
      if (!this.isHavePermission("ordersTwo:detail")) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！",
        });
        return;
      }
      let obj = {
        name: `订单详情2.0-${id}`,
        path: `/order2/orderdetail/${id}`,
      };
      window.open(obj.path);
      return false;
    },
    init(cate, paymentsId, payAmount, ordersList, platformCompanyId) {
      if (ordersList && ordersList.length > 0) {
        if (ordersList[0].type) {
          this.tabVal = 'sub';
        } else {
          this.tabVal = 'new';
        }
      }
      this.cate = cate;
      if (ordersList && ordersList.length > 0) {
        ordersList.map(i => {
          i.salesManName = i.salesMan;
          i.salesMan = i.salesManId;
        });
      }
      this.paymentsId = isEmpty(paymentsId) ? 0 : paymentsId;
      this.page.currentPage = 1;
      this.page2.currentPage = 1;
      this.isCheckboxAll = false;
      this.isCheckboxAll2 = false;
      this.platformCompanyId = platformCompanyId;
      this.payAmount = payAmount;
      this.ordersList = isEmpty(ordersList) ? [] : ordersList;
      this.searchOrdersNum = "";
      this.searchOrdersName = "";

      this.resMoneyMap = {};
      this.ordersList.forEach(item => {
        if (isNotEmpty(item.ordersId)) {
          item.checked = true;
          this.resMoneyMap[item.ordersId] = item;
        }
      });
      this.getOrderList();
      this.getSubOrder();
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getList(query, options, url, path, columnType) {
      let params = {};
      if (this.tabVal === 'new') {
        params = {
          cate: columnType,
          name: query
        };
      } else {
        params = {
          columnType: columnType,
          keyword: query,
        };
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i)
          }
        })
      }
    },
    changePage(e) {
      if (!this.submit()) {
        this.page.currentPage = this.currentPage === 0 ? 1 : this.currentPage;
        return;
      }

      this.page.pageSize = e.pageSize;
      if (this.currentPage != e.currentPage) {
        this.currentPage = e.currentPage;
        this.getOrderList();
      }
    },
    changePage2(e) {
      if (!this.submit()) {
        this.page2.currentPage = this.currentPage2 === 0 ? 1 : this.currentPage2;
        return;
      }
      if (this.currentPage2 != e.currentPage) {
        this.currentPage2 = e.currentPage;
        this.getSubOrder();
      }
    },
    search() {
      this.page.currentPage = 1;
      this.getOrderList();
    },
    search2() {
      this.page2.currentPage = 1;
      this.getSubOrder();
    },
    async getOrderList() {
      // 获取列表数据
      this.loading = true;
      // let platformCompanyIdList = [];
      // platformCompanyIdList.push(this.platformCompanyId);
      let url = 'selectRelatedMoneyList';
      let params = {
        platformCompanyId: this.platformCompanyId,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2
      };
      if (this.paymentsId !== 0 && !this.isEdit) {
        params.paymentsId = this.paymentsId;
        params.isShowOnly = 1;
        // params.flowState = 0;
        if (
            isEmpty(this.searchOrdersNum) &&
            isEmpty(this.searchOrdersName) &&
            isEmpty(this.searchOrdersBuyer) &&
            isEmpty(this.searchOrdersSeller) &&
            isEmpty(this.searchOrdersSaleMan) &&
            isEmpty(this.searchOrdersCarShipNum) &&
            this.ordersList.length > 0
        ) {
          url = "relatedMoneyList";
        }
      }
      if (this.searchOrdersNum) {
        params.ordersNum = this.searchOrdersNum;
      }
      if (this.searchOrdersName) {
        params.ordersTitle = this.searchOrdersName;
      }
      if (this.searchOrdersBuyer) {
        params.buyerName = this.searchOrdersBuyer;
      }
      if (this.searchOrdersSeller) {
        params.sellerName = this.searchOrdersSeller;
      }
      if (this.searchOrdersCompName) {
        params.compName = this.searchOrdersCompName;
      }
      if (this.searchOrdersCarShipNum) {
        params.carShipNum = this.searchOrdersCarShipNum;
      }
      if (this.searchOrdersSaleMan) {
        params.saleMan = this.searchOrdersSaleMan;
      }

      let res = await $api.twoOrders.post(url, params);

      if (res.status != 1) {
        if (isEmpty(res.message)) res.message = "接口异常";
        this.$refs.$XModal.message(res.mesage);
        return;
      }

      let tableData = res.data.rows;
      this.isCheckboxAll = true;
      tableData.map(i => {
        if (
            isNotEmpty(this.resMoneyMap[i.id]) &&
            isNotEmpty(this.resMoneyMap[i.id].aboutAmount)
        ) {
          i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
          i.aboutAmount = i.relatedAmount;
        } else {
          i.aboutAmount = null;
        }

        if (isEmpty(i.aboutAmount)) {
          i.checked = false;
          this.isCheckboxAll = false;
        } else {
          i.checked = true;
        }
      });
      this.tableData = tableData;
      this.page.totalResult = res.data.total;

      if (isNotEmpty(this.$refs.xTable)) {
        tableData.forEach(row => {
          if (row.checked == true) {
            this.$refs.xTable.setCheckboxRow(row, true);
          }
        });
      }
      this.loading = false;
    },
    async getSubOrder() {
      let params = {
        page: this.page2.currentPage,
        rows: this.page2.pageSize,
        orderBy: 2,
        ordersTitleAttached: this.ordersTitleAttached,
        ordersNumAttached: this.ordersNumAttached,
        platformCompanyIds: [],
        paymentsId: this.paymentsId
      };

      if (this.searchSellerName.length > 0) {
        params.sellerIds = this.searchSellerName;
      }
      if (this.searchSalesMan.length > 0) {
        params.saleManIds = this.searchSalesMan;
      }
      if (this.searchComp.length > 0) {
        params.platformCompanyIds = this.searchComp;
      } else {
        params.platformCompanyIds.push(this.platformCompanyId);
      }

      this.loading2 = true;
      let res = await $api.twoOrders.post("relatedAttachedMoneyList", params);
      this.loading2 = false;
      if (res.status === 1) {
        let tableData = res.data.rows;
        this.isCheckboxAll = true;
        tableData.map(i => {
          if (
              isNotEmpty(this.resMoneyMap[i.id]) &&
              isNotEmpty(this.resMoneyMap[i.id].aboutAmount)
          ) {
            i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
            i.aboutAmount = i.relatedAmount;
          } else {
            i.aboutAmount = null;
          }

          if (isEmpty(i.aboutAmount)) {
            i.checked = false;
            this.isCheckboxAll = false;
          } else {
            i.checked = true;
          }
        });

        this.orderType.map(i => {
          tableData.map(j => {
            if (j.ordersType === i.value) {
              j.ordersTypeText = i.label;
            }
          })
        })
        this.orderListData.map(i => {
          if (isNotEmpty(this.resMoneyMap[i.id]) && isNotEmpty(this.resMoneyMap[i.id].aboutAmount)) {
            i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
            i.aboutAmount = i.relatedAmount;
          } else {
            i.aboutAmount = null;
          }
          if (isEmpty(i.aboutAmount)) {
            i.checked = false;
            this.isCheckboxAll = false;
          } else {
            i.checked = true;
          }
        })

        this.orderListData = tableData;
        this.page2.totalResult = res.data.total;

        if (isNotEmpty(this.$refs.xTable2)) {
          tableData.forEach(row => {
            if (row.checked == true) {
              this.$refs.xTable2.setCheckboxRow(row, true);
            }
          });
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cellClick(e) {
    },
    checkboxChange({row, $rowIndex}) {
      row.checked = row.checked == true ? false : true;
      let data = this.$refs.xTable.getCheckboxRecords();
      if (data.length === 1 && row.checked == true) {
        this.resMoneyMap[row.id] = row;
        row.aboutAmount = this.payAmount;
      }
      // row.checked = row.checked == true ? false : true;
      if (row.checked === false && isNotEmpty(this.resMoneyMap[row.id])) {
        delete this.resMoneyMap[row.id];
      }
      if (row.checked === false) {
        this.isCheckboxAll = false;
      }
    },
    checkBoxAll(e) {
      this.isCheckboxAll = this.isCheckboxAll == true ? false : true;
      this.tableData.forEach(item => (item.checked = this.isCheckboxAll));
      if (this.isCheckboxAll == false) {
        this.tableData.forEach(item => {
          item.aboutAmount = null;
          if (isNotEmpty(this.resMoneyMap[item.id])) {
            delete this.resMoneyMap[item.id];
          }
        });
      }
      this.$refs.xTable.updateStatus();
    },
    checkboxChange2({row, $rowIndex}) {
      row.checked = row.checked == true ? false : true;
      let data = this.$refs.xTable2.getCheckboxRecords();
      if (data.length === 1 && row.checked == true) {
        this.resMoneyMap[row.id] = row;
        row.aboutAmount = this.payAmount;
      }
      // row.checked = row.checked == true ? false : true;
      if (row.checked === false && isNotEmpty(this.resMoneyMap[row.id])) {
        delete this.resMoneyMap[row.id];
      }
      if (row.checked === false) {
        this.isCheckboxAll2 = false;
      }
    },
    checkBoxAll2(e) {
      this.isCheckboxAll2 = this.isCheckboxAll2 == true ? false : true;
      this.orderListData.forEach(item => (item.checked = this.isCheckboxAll2));
      if (this.isCheckboxAll == false) {
        this.orderListData.forEach(item => {
          item.aboutAmount = null;
          if (isNotEmpty(this.resMoneyMap[item.id])) {
            delete this.resMoneyMap[item.id];
          }
        });
      }
      this.$refs.xTable2.updateStatus();
    },
    inputAboutAmount(row) {
      row.checked = true;
      this.resMoneyMap[row.id] = row;
    },
    toggleGoods(id) {
      this.$refs[id].togglePanel();
    },
    submit(isSubmit) {
      if (this.cate == "Collection") {
        let arr = [];
        for (var id in this.resMoneyMap) {
          let item = this.resMoneyMap[id].buyerName;
          arr.push(item);
        }
        arr = [...new Set(arr)];
        if (arr.length > 1) {
          this.$XModal.message({message: "关联的订单托运人不一致，请核对"});
          return;
        }
      }
      let usedAmount = 0;
      let resAmountList = [];
      //选中关联金额要填
      var errMsg = "";
      let payAmount = Math.round(this.payAmount * 100) / 100;
      this.tableData.forEach(item => {
        let itemAboutAmount = Math.round(item.aboutAmount * 100) / 100;

        if (item.checked == true) {
          if (isEmpty(item.aboutAmount)) {
            errMsg = "请填写关联金额";
          } else if (
              isNaN(parseFloat(item.aboutAmount)) ||
              (payAmount > 0 && itemAboutAmount < 0) ||
              (payAmount < 0 && itemAboutAmount > 0)
          ) {
            errMsg = "关联金额错误";
          }
        }
      });

      if (isNotEmpty(errMsg)) {
        this.$XModal.message({message: errMsg});
        return false;
      }

      //整理关联数据
      for (var ordersId in this.resMoneyMap) {
        let item = this.resMoneyMap[ordersId];
        if (item.checked == true) {
          if (isEmpty(item.aboutAmount) || item.aboutAmount == 0) {
            this.$XModal.message({message: "请填写关联金额"});
            return false;
          } else {
            if (this.tabVal === 'new') {
              resAmountList.push({
                id: item.id,
                buyerId: item.buyerId,
                sellerId: item.sellerId,
                ordersId: ordersId,
                ordersNum: item.ordersNum,
                aboutAmount: parseFloat(item.aboutAmount),
                salesMan: item.saleMan,
                rateManage: item.rateManage,
                buyerName: item.buyerName,
                sellerName: item.sellerName
              });
            } else {
              resAmountList.push({
                id: item.id,
                aboutAmount: parseFloat(item.aboutAmount),
                ordersId: item.id,
                ordersNum: item.ordersNumAttached,
                salesMan: item.saleMan,
                salesManId: item.saleManId,
                type: 'sub'
              });
            }
            usedAmount += parseFloat(item.aboutAmount);
          }
        }
      }
      if (
          (payAmount > 0 &&
              Math.round(usedAmount * 100) > Math.round(this.payAmount * 100)) ||
          (payAmount < 0 &&
              Math.round(usedAmount * 100) < Math.round(this.payAmount * 100))
      ) {
        let message =
            this.cate == "Collection"
                ? "关联金额不能超过收款金额"
                : "关联金额不能超过付款金额";
        this.$XModal.message({message});
        return false;
      }
      if (usedAmount > 0) usedAmount = parseInt(usedAmount * 100) / 100;

      if (isSubmit) {
        // console.log(resAmountList);
        // debugger
        this.$emit("choose", resAmountList, usedAmount, this.tabVal === 'sub' ? 'sub' : null);
      } else {
        return true;
      }
    },
    openDetail(id) {
      let obj = {};
      obj.name = `附属订单详情${id}`
      obj.path = `/subOrder/orderdetail/${id}`
      window.open(obj.path);
    },
  }
};
</script>

<style scoped>
.vxe-pager .vxe-pager--wrapper {
  position: relative;
}

.vxe-pager .vxe-pager--sizes {
  height: 28px !important;
}

.modal-header {
  position: relative;
  height: 60px;
}

.my-search {
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

.my-search >>> .ivu-select-selection {
  height: 34px;
  border-radius: 0;
}

.my-search >>> .ivu-icon-ios-arrow-down {
  position: absolute;
  right: 5px;
  top: 10px;
  color: #999;
  cursor: pointer;
}

.my-search .vxe-input {
  height: 34px;
  width: 400px;
  vertical-align: middle;
}

/*.my-search .vxe-input >>> .vxe-input--suffix {*/
/*  display: block !important;*/
/*  width: 60px;*/
/*  height: 32px;*/
/*  top: 1px;*/
/*  text-align: center;*/
/*  border-left: 1px solid #dcdfe6;*/
/*  background-color: #f5f7fa;*/
/*  cursor: pointer;*/
/*}*/

.my-search .vxe-input >>> .vxe-input--inner {
  border: 1px solid #dcdfe6;
}

.btn-down {
  border: none;
  background: transparent;
}

.btn-down:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.link-text {
  margin-right: 30px;
  margin-left: 10px;
}

/*.ivu-btn.ivu-btn-primary {*/
/*  width: 140px;*/
/*  height: 40px;*/
/*}*/

.choose-match-invoice .vxe-radio-group,
.choose-match-invoice .tab-list {
  width: 100%;
  box-sizing: border-box;
}

.choose-match-invoice .tab-list {
  border-bottom: 1px solid #dcdee2;
}

.choose-match-invoice .tab-list li {
  padding: 0 20px;
  margin-right: 0px;
}

.choose-match-invoice .my-search {
  margin-top: 10px;
  position: relative;
}
</style>